module.exports = __webpack_public_path__ + "static/media/invite-hex.8d0a48d8.svg";